import { AfterViewInit, Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { IUser } from '../user';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../user.service';
import { FormBuilder, FormControlName, FormGroup, Validators } from '@angular/forms';
import { GenericValidator } from '../../shared/generic-validator';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import { IBranch } from '../../branches/branch';
import { BranchService } from '../../branches/branch.service';
import { environment } from '../../../environments/environment';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { USER_ROLES, Helper } from '../../shared/helper';

@Component({
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit, AfterViewInit {
  @ViewChildren(FormControlName, { read: ElementRef })
  formInputElements: ElementRef[];

  pageTitle: string;
  errorMessage: string;
  userForm: FormGroup;
  user: IUser;
  displayMessages: any = {};
  private _validationMessages: { [key: string]: { [key: string]: string } };
  private _genericValidator: GenericValidator;
  branches: IBranch[];
  roles = USER_ROLES;
  apiUrl = environment.apiUrl;
  disableForm = true;

  constructor(
    private _fb: FormBuilder,
    private _userService: UserService,
    private branchService: BranchService,
    public activeModal: NgbActiveModal,
    private helper: Helper
  ) {
    this._validationMessages = {
      username: { required: 'Username is required.' },
      password: { required: 'Password is required.' },
      isActive: { required: 'Is active is required.' },
      branch: { required: 'Branch is required.' },
      role: { required: 'Role is required.' }
    };
    this._genericValidator = new GenericValidator(this._validationMessages);
    this.branchService.getBranches({}).subscribe(res => {
      this.branches = res.body;
      this.disableForm = false;
    }, error => (this.errorMessage = <any>error));
  }

  ngOnInit(): void {
    this.userForm = this._fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      isActive: ['', Validators.required],
      branch: ['', Validators.required],
      role: ['', Validators.required]
    });

    if (this.user.id === 0) {
      this.pageTitle = 'Add User';
    } else {
      this.pageTitle = `Edit User: ${this.user.username}`;
      this.userForm.controls['password'].setValidators(null);
      this.userForm.controls['password'].updateValueAndValidity();
      this.userForm.patchValue({
        username: this.user.username,
        isActive: this.user.isActive,
        branch: this.user.branch.id,
        role: this.user.role
      });
    }
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements.map(
      (formControl: ElementRef) =>
        Observable.fromEvent(formControl.nativeElement, 'blur')
    );

    Observable.merge(this.userForm.valueChanges, ...controlBlurs)
      .debounceTime(200)
      .subscribe(value => {
        this.displayMessages = this._genericValidator.processMessages(
          this.userForm
        );
      });
  }

  saveUser() {
    this.disableForm = true;
    this.helper.clearEmptyFormFilds(this.userForm);
    if (this.userForm.dirty && this.userForm.valid) {
      this.userForm.controls['branch'].setValue(
        '/branches/' + this.userForm.value.branch
      );
      if (this.userForm.value['password'] === '') {
        this.userForm.removeControl('password');
      }
      const l = Object.assign({}, this.user, this.userForm.value);
      this._userService.saveUser(l).subscribe(res => {
        this.userForm.reset();
        this.activeModal.close(res);
      }, (error: any) => (this.errorMessage = <any>error));
    }
  }

  closeActiveModal() {
    if (this.userForm.dirty) {
      if (confirm(`Are you sure to close form?`)) {
        this.activeModal.dismiss();
      }
    } else {
      this.activeModal.dismiss();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/users/single/user.component.ts